import { Injectable } from '@angular/core';

import { Subscription ,  BehaviorSubject } from 'rxjs';

@Injectable()
export class LocDataService {
    lat: string;
    lon: string;
    zipCode: string;
}

@Injectable()
export class LocTrackingService {

  public trackingLoaded = new BehaviorSubject(false);

  private subscriptions = new Subscription();
  private R = 6371; // km
  constructor(
      private dataService: LocDataService,
  ) {
    this.initTracking();
  }

  initTracking() {
    if (window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(this.setPosition.bind(this));
      window.navigator.geolocation.watchPosition(this.setPosition.bind(this));
    } else {
      this.trackingLoaded.next(true);
    }
  }
  isLocationTrackingAllowed() : boolean {
    const location = this?.getLocation();
    return location?.latitude !== undefined && location?.longitude !== undefined;
  }
  setPosition(location: any) {
    if (location.coords !== undefined && this.dataService.lat === undefined) {
      this.dataService.lat = location.coords.latitude as string;
      this.dataService.lon = location.coords.longitude as string;
    }
    this.trackingLoaded.next(true);
  }

  updateLocation(location: any) {
    if (location.latitude !== undefined) {
      this.dataService.lat = location.latitude as string;
      this.dataService.lon = location.longitude as string;
    }
  }

  updateZipCode(zip: string) {
    this.dataService.zipCode = zip;
  }

  updateLongitude(lon: any) {
    this.dataService.lon = lon as string;
  }

  updateLatitude(lat: any) {
    this.dataService.lat = lat as string;
  }

  getLocation() {
    const location = { latitude: this.dataService.lat, longitude: this.dataService.lon };

    return location;
  }

  getLongitude() {
    return this.dataService.lon;
  }

  getLatitude() {
    return this.dataService.lat;
  }

  getZipCode() {
    return this.dataService.zipCode;
  }

  public calcCrowInMiles(fromLat: number, fromLon: number, toLat: number, toLon: number) {
    
    const dLat = this.toRad(toLat - fromLat);
    const dLon = this.toRad(toLon - fromLon);
    const fromLatRad = this.toRad(fromLat);
    const toLatRad = this.toRad(toLat);

    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(fromLatRad) * Math.cos(toLatRad);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = this.R * c * 0.621371; // Convert to miles
    return d;
  }

  // Converts numeric degrees to radians
  private toRad(value) {
    return value * Math.PI / 180;
  }
}
